import MaterialListSubheader, {
    ListSubheaderProps,
} from '@mui/material/ListSubheader';

export function ListSubheader(props: ListSubheaderProps) {
    return (
        <MaterialListSubheader
            data-testid={'ListSubheader-container'}
            {...props}
        />
    );
}

export default ListSubheader;
